'use strict';
// tslint:disable
/**
 * Multimedia Server Api
 * Мультимедиа сервер апи
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, '__esModule', { value: true });
exports.Configuration = void 0;
var Configuration = /** @class */ (function () {
  function Configuration(param) {
    if (param === void 0) {
      param = {};
    }
    this.apiKey = param.apiKey;
    this.username = param.username;
    this.password = param.password;
    this.accessToken = param.accessToken;
    this.basePath = param.basePath;
    this.baseOptions = param.baseOptions;
  }
  return Configuration;
})();
exports.Configuration = Configuration;
